import { render, staticRenderFns } from "./ProductionNewsBlock.vue?vue&type=template&id=ae6d8cc0&scoped=true&"
import script from "./ProductionNewsBlock.vue?vue&type=script&lang=ts&"
export * from "./ProductionNewsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionNewsBlock.vue?vue&type=style&index=0&id=ae6d8cc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6d8cc0",
  null
  
)

export default component.exports